module.exports = __webpack_public_path__ + "static/media/logo.9864cdf0.svg";